import type {User} from 'src/typings';

export interface RegistrationOptionActions {
    [x: string]: RegistrationOptionAction;
}

export class RegistrationOptions {

    constructor(private options: RegistrationOptionActions) {
    }

    public isAny(): boolean {
        return this.getEnabledKeys().length > 0;
    }

    public isOnlyOne(): boolean {
        return this.getEnabledKeys().length === 1;
    }

    public doFirstEnabled(): Promise<User> {
        return this.getFirstEnabled().doAction();
    }

    public get(name: string): RegistrationOptionAction {
        return this.options[name];
    }

    private getEnabledKeys(): string[] {
        return Object.keys(this.options)
                     .filter((key) => this.options[key].isEnabled());
    }

    private getFirstEnabled() {
        for (const key in this.options) {
            if (Object.hasOwn(this.options, key) && this.options[key].isEnabled()) {
                return this.options[key];
            }
        }

        return null;
    }
}

 
export class RegistrationOptionAction {

    constructor(private enabled: boolean,
                private doActionFunction: () => Promise<User>) {
    }

    public isEnabled(): boolean {
        return this.enabled;
    }

    public doAction(): Promise<User> {
        return this.doActionFunction();
    }
}
